/* Swissöra · personalization & presence
   1) PostHog identify (logged-in customer via window.SW_CUSTOMER, or any email typed)
   2) Returning-visitor greeting in the hero ("Bon retour, {prénom}")
   3) Live-online dot (heuristic presence — wire to a real source server-side later)
   Loaded after partials.js, which injects the header/hero asynchronously → we retry. */
(function () {
  var NAME_KEY = 'swissora_name', EMAIL_KEY = 'swissora_email';

  function storeName(n) { try { if (n) localStorage.setItem(NAME_KEY, n); } catch (e) {} }
  function storeEmail(e) { try { if (e) localStorage.setItem(EMAIL_KEY, e); } catch (x) {} }
  /* used by partials.js "M'avertir du retour": if we already know the email,
     skip the prompt and confirm directly. */
  window.SwissoraKnownEmail = function () {
    try { var c = window.SW_CUSTOMER; return localStorage.getItem(EMAIL_KEY) || (c && c.email) || ''; }
    catch (e) { return ''; }
  };
  function getName() {
    try {
      var c = window.SW_CUSTOMER;
      return localStorage.getItem(NAME_KEY) || (c && (c.first_name || (c.name || '').split(' ')[0])) || '';
    } catch (e) { return ''; }
  }
  function whenReady(sel, cb, tries) {
    tries = tries || 0;
    var el = document.querySelector(sel);
    if (el) return cb(el);
    if (tries < 24) setTimeout(function () { whenReady(sel, cb, tries + 1); }, 250);
  }

  /* 1 · identify ------------------------------------------------------------ */
  function identify() {
    var c = window.SW_CUSTOMER;
    try {
      if (window.posthog && c && c.id) {
        posthog.identify(String(c.id), {
          email: c.email || undefined, name: c.name || undefined,
          first_name: c.first_name || undefined, orders_count: c.orders_count || 0
        });
      }
    } catch (e) {}
    if (c && c.first_name) storeName(c.first_name);
    if (c && c.email) storeEmail(c.email);
  }
  /* capture an email the visitor types anywhere (Swiss Club waitlist, newsletter) */
  document.addEventListener('submit', function (e) {
    try {
      var em = e.target.querySelector && e.target.querySelector('input[type="email"]');
      if (em && em.value) { storeEmail(em.value); if (window.posthog) posthog.identify(em.value, { email: em.value }); }
    } catch (x) {}
  }, true);

  /* current language (set by i18n.js via localStorage + <html data-lang>) */
  function isEN() {
    try {
      return (window.SwissoraI18n && window.SwissoraI18n.lang === 'en') ||
             localStorage.getItem('swissora_lang') === 'en' ||
             document.documentElement.getAttribute('data-lang') === 'en';
    } catch (e) { return false; }
  }

  /* 2 · returning greeting -------------------------------------------------- */
  function greet() {
    var name = getName();
    if (!name) return;
    whenReady('.hero__h1', function (h1) {
      if (document.querySelector('.hero-greet')) return;
      var g = document.createElement('span');
      g.className = 'hero-greet';
      g.textContent = (isEN() ? 'Welcome back, ' : 'Bon retour, ') + name + ' ✦';
      h1.parentNode.insertBefore(g, h1);
    });
  }

  /* 3 · live-online dot (heuristic) ---------------------------------------- */
  function liveCount() {
    var h = new Date().getHours();
    var base = 9 + Math.round(7 * Math.sin((h - 4) / 24 * Math.PI * 2)) + Math.round(h >= 9 && h <= 23 ? 6 : 0);
    return Math.max(4, base + Math.floor(Math.random() * 5) - 2);
  }
  /* 30+ noms + 30+ villes → combinaisons randomisées, jamais répétitives */
  var PNAMES = ['Léa', 'Camille', 'Manon', 'Chloé', 'Inès', 'Sarah', 'Emma', 'Jade', 'Louise', 'Alice', 'Juliette', 'Clara', 'Anaïs', 'Océane', 'Margaux', 'Charlotte', 'Zoé', 'Lucie', 'Pauline', 'Elsa', 'Nina', 'Maëlys', 'Romane', 'Lina', 'Eva', 'Lou', 'Agathe', 'Capucine', 'Léna', 'Ambre', 'Mathilde', 'Justine'];
  var PCITIES = ['Paris', 'Lyon', 'Marseille', 'Toulouse', 'Bordeaux', 'Lille', 'Nantes', 'Nice', 'Strasbourg', 'Montpellier', 'Rennes', 'Grenoble', 'Bruxelles', 'Genève', 'Lausanne', 'Annecy', 'Aix-en-Provence', 'Cannes', 'Biarritz', 'Tours', 'Dijon', 'Reims', 'Nancy', 'Rouen', 'Angers', 'Pau', 'Avignon', 'Versailles', 'Saint-Étienne', 'Le Mans'];
  /* Uniquement des offres réellement achetables (SwissLash 1/2/3 mois) —
     SwissBrow & SwissMascara sont "bientôt disponibles", jamais dans le social proof. */
  var PPRODUCTS = [
    { n: 'le sérum SwissLash', e: 'the SwissLash serum', i: 'product_swisslash.webp' },
    { n: 'SwissLash — Sérum cils', e: 'SwissLash — Lash serum', i: 'product_swisslash.webp' },
    { n: 'la Cure SwissLash 2 mois', e: 'the SwissLash 2-month course', i: 'product_swisslash.webp' },
    { n: 'la Cure SwissLash 3 mois', e: 'the SwissLash 3-month course', i: 'product_swisslash.webp' }
  ];
  function rnd(a) { return a[Math.floor(Math.random() * a.length)]; }
  function assetUrl(f) {
    if (window.SHOPIFY_ASSET_BASE) return window.SHOPIFY_ASSET_BASE + f;
    var im = document.querySelector('.pdp__main-img img, .pcard__media img, .sticky-atc__img');
    return (im && (im.currentSrc || im.src)) || '';
  }
  function mountLive() {
    if (document.querySelector('.live-dot')) return;
    var el = document.createElement('span');
    el.className = 'live-dot';
    el.innerHTML = '<img class="live-dot__pic" alt="" /><span class="live-dot__led"></span><span class="live-dot__n"></span>';
    document.body.appendChild(el); /* fixed bottom-left via CSS */
    var nEl = el.querySelector('.live-dot__n'), picEl = el.querySelector('.live-dot__pic');
    function online() { nEl.textContent = liveCount() + (isEN() ? ' online' : ' en ligne'); el.classList.remove('live-dot--buy'); }
    function buy() {
      var nm = rnd(PNAMES), city = rnd(PCITIES), pr = rnd(PPRODUCTS);
      picEl.src = assetUrl(pr.i);
      nEl.innerHTML = isEN()
        ? '<strong>' + nm + '</strong> from ' + city + ' just bought ' + (pr.e || pr.n)
        : '<strong>' + nm + '</strong> de ' + city + ' vient d\'acheter ' + pr.n;
      el.classList.add('live-dot--buy');
      if (el.animate) el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.05)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'ease-out' });
    }
    online();
    /* mostly shows the live count; occasionally a "just bought" beat (random name/city/produit) */
    function cycle() {
      if (Math.random() < 0.5) {
        buy();
        setTimeout(function () { if (Math.random() < 0.35) { buy(); setTimeout(online, 4200); } else { online(); } }, 4200);
      } else { online(); }
      setTimeout(cycle, 9000 + Math.floor(Math.random() * 8000));
    }
    setTimeout(cycle, 6000);
  }

  function init() { identify(); greet(); mountLive(); }
  if (document.readyState !== 'loading') setTimeout(init, 350);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 350); });
})();
